<lib-ags-loading *ngIf="loader"></lib-ags-loading>

<div
  *ngIf="!!presenceInfo && !!dataOfPresence && !loader"
  class="uk-card uk-card-default uk-overflow-auto uk-margin-large-right uk-margin-medium-bottom center"
  style="margin-top: 15px"
>
  <div class="uk-card-body uk-padding-remove">
    <table class="uk-table uk-table-small uk-table-divider">
      <thead>
        <th class="center">Apprenant</th>
        <th *ngFor="let item of dataOfPresence" class="center">
          {{ item.date_session | date: 'dd/MM/yyyy' }}
          <br />
          {{ item.horaires }}
        </th>
      </thead>

      <tr *ngFor="let item of presenceInfo; let i = index">
        <td>
          {{ presenceInfo[i].nom }}
        </td>
        <td *ngFor="let elm of presenceInfo[i].sessionApprenantPlanifications" (click)="open(item, elm)">
          <input
            *ngIf="!(elm.b_retard || elm.b_depart_anticipe)"
            type="checkbox"
            class="checkbox"
            [checked]="elm.present"
          />
          <span *ngIf="elm.b_retard" class="contrainte-text">Arrivée {{ elm.heure_retard }}</span>
          <span *ngIf="elm.b_depart_anticipe" class="contrainte-text">Départ {{ elm.heure_depart_anticipe }}</span>
        </td>
      </tr>
    </table>
  </div>
</div>
<div
  *ngIf="(!presenceInfo || !dataOfPresence) && !loader"
  class="uk-overflow-auto uk-margin-large-right
  notfoundApprenant
  uk-margin-medium-bottom"
>
  Pas d'apprenant(s) pour cette session
</div>
<ags-popup-presence
  [presenceApprenantInfoChoosed]="presenceApprenantInfoChoosed"
  [presenceApprenantDataChoosed]="presenceApprenantDataChoosed"
  (close)="closePopup()"
  *ngIf="opened"
></ags-popup-presence>
